import Marquee from "react-fast-marquee";
import { Reveal, SectionHeading } from "./Reveal";
import { INDUSTRIES } from "../../lib/data";

export const Industries = () => (
  <section id="industries" className="overflow-hidden border-y border-gray-200 bg-fog py-24 md:py-32" data-testid="industries-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeading
        overline="Industries We Serve"
        title="Financing Solutions Across Industries"
        sub="Understanding different businesses, assets, and financing requirements."
        testId="industries-heading"
      />
    </div>

    <div className="my-14 opacity-80" data-testid="industries-marquee">
      <Marquee speed={13} gradient={false}>
        {INDUSTRIES.map((ind) => (
          <span key={ind.name} className="mx-10 whitespace-nowrap font-heading text-6xl font-bold tracking-tight text-outline md:text-8xl">
            {ind.name.toUpperCase()}
          </span>
        ))}
      </Marquee>
    </div>

    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 px-5 sm:grid-cols-2 md:px-8 lg:grid-cols-3">
      {INDUSTRIES.map((ind, i) => {
        const Icon = ind.icon;
        return (
          <Reveal key={ind.name} delay={(i % 3) * 0.08} y={28} className="h-full">
            <div
              className="glow-hover flex h-full items-center gap-5 rounded-xl border border-gray-200 bg-white p-6 shadow-[0_2px_10px_rgba(16,20,24,0.04)]"
              data-testid={`industry-card-${ind.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-gold-line bg-gold-tint text-gold-deep">
                <Icon size={20} strokeWidth={1.6} />
              </span>
              <h3 className="font-heading text-lg font-semibold tracking-tight text-navy">{ind.name}</h3>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
